import { GetStaticPaths, GetStaticProps } from 'next';

import client from '@utils/apolloClient';
import { getNewsEntryPoints } from '@queries/news.graphql';

import getEntryBoxInfo from '@utils/getEntryBoxInfo';
import getPagination from '@utils/getPagination';

import Layout from '@components/Layout/Layout';
import ListingPage, { ListingProps } from '@components/ListingPage/ListingPage';

interface NewsPageProps extends ListingProps, ListingPage {}

const NewsPage = ({
  currentPage,
  description,
  featureFlags,
  posts,
  pages,
  siteTitle,
}: NewsPageProps) => {
  const section = 'News';
  const title = currentPage === 1 ? 'Latest News' : 'News Archive';

  return (
    <Layout
      featureFlags={featureFlags}
      pageDescription={description}
      pageTitle={title}
      pageType="website"
      section={section}
      siteTitle={siteTitle}
      url={`/news/archive/${currentPage}`}
    >
      <ListingPage
        posts={posts}
        pages={pages}
        section={section}
        title={title}
      />
    </Layout>
  );
};

export default NewsPage;

export const getStaticProps: GetStaticProps = async ({ ...ctx }) => {
  const siteConfig = await import(`~/siteconfig.json`);
  const currentPage: number = Number(ctx.params?.page || 1);

  const {
    data: { NewsItems: news },
  } = await client.query({
    query: getNewsEntryPoints,
    variables: {
      page: currentPage,
      length: siteConfig.pageSize,
    },
  });

  let pages = getPagination(
    'news',
    news.total,
    siteConfig.pageSize,
    currentPage
  );

  return {
    props: {
      currentPage,
      featureFlags: siteConfig.featureFlags,
      description: siteConfig.description,
      posts: news.items.map((item) => getEntryBoxInfo(item, 'News')),
      pages,
      siteTitle: siteConfig.title,
    },
  };
};

export const getStaticPaths: GetStaticPaths = async () => {
  const siteConfig = await import(`~/siteconfig.json`);
  const {
    data: { NewsItems: news },
  } = await client.query({
    query: getNewsEntryPoints,
  });

  let pages: Array<{ path: string }> = getPagination(
    'news',
    news.total,
    siteConfig.pageSize
  );
  let paths = pages.map((page) => page.path);

  return {
    paths,
    fallback: false,
  };
};
